import { Recurso } from "lib.common/dist/CleanArch";
import { EstadosApisDtSource } from "../../bussines/dataSources/EstadosApisDtSource";
import { EstadoApi } from "../../bussines/entities/EstadoApi.entity";
import { transformacion } from 'lib.common';
import { urls } from "src/config/keys";
import { ErrExterno } from 'lib.common/dist/errorHandler';

export class EstadosApisDtSourceImplRest implements EstadosApisDtSource {
    private apikey: string;
    constructor(apikey: string) {
        this.apikey = apikey;
    }
    async getEstadosApis(): Promise<Recurso<EstadoApi[]>> {
        try {
            let url = transformacion.appendUrl(urls.backEnd, '/apis/estadoApis');
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    dsmonitoreokey: this.apikey
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de las apis.');
            }

            const data: EstadoApi[] = await response.json();
            return Recurso.fromData<EstadoApi[]>(data);
        } catch (error) {
            return Recurso.fromError<EstadoApi[]>(new ErrExterno(error as Error));
        }
    }

    async getEstadosApisTransporte(): Promise<Recurso<EstadoApi[]>> {
        try {
            let url = transformacion.appendUrl(urls.backEnd, '/apis/estadoApisTransporte');
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    dsmonitoreokey: this.apikey
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de las apis de transporte.');
            }

            const data: EstadoApi[] = await response.json();
            return Recurso.fromData<EstadoApi[]>(data);
        } catch (error) {
            return Recurso.fromError<EstadoApi[]>(new ErrExterno(error as Error));
        }
    }
}